<template>
  <div class="inicio">
    <div class="cover">

      <video id="v-escritorio" class="video" autoplay muted loop playsinline>
        <source :src="`${cdnArchivosSargazo}/enis/energia/sargazo/portadas/web_1.mp4`" type="video/mp4">
      </video>
      <video id="v-movil" class="video" autoplay muted loop playsinline>
        <source :src="`${cdnArchivosSargazo}/enis/energia/sargazo/portadas/movil.mp4`" type="video/mp4">
      </video>


      <div class="cover-gradient">
        <h1 class="cover-title a11y-contraste-fondo">
          Arribo del sargazo pelágico a las costas mexicanas
        </h1>
        <h2 class="cover-subtitle a11y-contraste-fondo">
          Un capítulo del Ecosistema Nacional Informático de
          {{ obtenerNombreEni }}
        </h2>
      </div>
    </div>
    <div class="a11y-simplificada-block">
      <div class="container text">
        <h2 class="titular-portada m-t-1-sm m-t-3-md">
          Arribo del sargazo pelágico a las costas mexicanas
        </h2>
        <h3 class="titular-portada sub">
          Un capítulo del Ecosistema Nacional Informático de
          {{ obtenerNombreEni }}
        </h3>
      </div>
    </div>

    <div class="container text m-t-1-sm m-b-3-sm m-y-2-md">
      <p class="texto-primario">
        El sargazo es un conjunto de algas marinas que cumplen con funciones ecológicas importantes.
        Las especies <i>Sargassum natans</i> y <i>Sargassum fluitans</i> son organismos flotantes
        que han arribado de forma masiva a las playas del Caribe, entre ellas, el Caribe Mexicano.
        Las arribazones masivas han acarreado múltiples daños, representando un gran reto que debe
        atenderse de forma integral, coordinada, transdisciplinaria e interinstitucionalmente.
      </p>
      <router-link class="link" to="/contexto">Más contexto</router-link>
    </div>

    <div class="container text m-t-1-sm m-b-3-sm m-y-2-md">
      <p class="titulo" :class="{ 'border-bottom-none': tieneVistaSimplificada }">
        Comunidad involucrada en la atención, adaptación y mitigación de sargazo.
      </p>
      <p>
        Con el objetivo de conectar a la comunidad que trabaja en temas relacionados con el sargazo,
        se desarrolló el mapa de actores, que permite encontrar información sobre las personas que
        actualmente atienden dicho tema bajo el marco de líneas estratégicas para la atención,
        adaptación y mitigación del arribo de sargazo pelágico al Caribe Mexicano.
      </p>
    </div>

    <MapaActores class="ocultar-vista-simplificada m-t-1-sm m-b-3-sm m-y-2-md" />

    <div class="container text m-t-1-sm m-b-3-sm m-y-2-md">
      <p class="titulo" :class="{ 'border-bottom-none': tieneVistaSimplificada }">
        Encuesta pública para generar una base de datos sobre el sargazo de origen pelágico en las
        costas mexicanas.
      </p>
      <p>
        Con la intención de mantener actualizado el presente mapa de actores, así como promover la
        colaboración entre los diversos sectores de la población para un óptimo desarrollo de
        acciones, el Conahcyt convoca a toda la población interesada a participar en esta encuesta.
        El objetivo de la misma es identificar ciudadanos comprometidos con llevar a cabo acciones
        que permitan afrontar de manera colectiva los impactos ocasionados por las arribazones de
        sargazo, y con ello compilar esfuerzos como investigaciones, desarrollos tecnológicos,
        articulación de normativas, programas de carácter social, acciones de divulgación, etc. En
        particular, la información recabada permitirá:
      </p>

      <ul>
        <li>
          Obtener un completo y actualizado mapeo de actores relacionados a la temática del sargazo
          en México.
        </li>
        <li>
          Identificar grupos de trabajo en las distintas áreas del conocimiento necesarias para la
          comprensión del fenómeno.
        </li>
        <li>Identificar avances, vacíos, y omisiones de conocimiento.</li>
        <li>
          Identificar y priorizar las distintas necesidades de investigación, desarrollo tecnológico
          y acciones sociales.
        </li>
        <li>
          Impulsar y facilitar la comunicación y el intercambio de conocimiento entre los distintos
          actores involucrados.
        </li>
      </ul>
    </div>

    <div class="container text m-t-1-sm m-b-3-sm m-y-2-md a11y-simplificada-block">
      <a
        href="https://docs.google.com/forms/d/e/1FAIpQLSdM2lwTbT7jA2Hz31cPtHrMvU3FWz62U7gBeFj99tVSIq-YAA/viewform"
      >
        <b>Encuesta pública</b>
      </a>
    </div>
  </div>
</template>

<script>
import MapaActores from "@/components/mapas/MapaActores";
import { mapGetters  } from "vuex";

export default {
  name: "Inicio",
  data() {
    return {
      domain: process.env.VUE_APP_ENI_DOMAIN,
      base_route: process.env.VUE_APP_BASE_ROUTE,
      cdnArchivosSargazo: process.env.VUE_APP_CDN_ARCHIVOS
    };
  },
  computed: {
    // ...mapGetters(['cdnArchivosSargazo']),

    obtenerNombreEni() {
      return this.$store.getters.obtenerNombreEni;
    },
    tieneVistaSimplificada() {
      return this.$store.getters.tieneVistaSimplificada;
    },
  },
  components: {
    MapaActores,
  },
};
</script>

<style lang="scss" scoped>
.inicio {
  .cover {
  .video {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    &.hidden{
      display: none;
    }
  }
  #v-escritorio {
    display: none;
    @media (min-width: map-get($media-queries-limit, "mobile")) {
      display: block;
    }
  }
  #v-movil {
    display: block;
    @media (min-width: map-get($media-queries-limit, "mobile")) {
      display: none;
    }
  }



    .cover-gradient {
      .cover-title {
        font-weight: 400;
        @media (min-width: map-get($media-queries-limit, "mobile")) {
          font-weight: 600;
        }
      }
    }
  }
  .container.text {
    .titulo {
      font-size: 24px;
      line-height: 28px;
      font-weight: 400;
      padding-bottom: 8px;
      border-bottom: 1px solid #000;
      &.border-bottom-none {
        border-bottom: none;
      }
    }
    .titular-portada {
      text-align: left;
      max-width: inherit;
      // max-width: 737px;
      font-size: 52px;
      font-weight: 600;
    }
    .titular-portada.sub {
      // max-width: 505px;
      font-size: 21px;
      font-weight: 400;
    }
    .investigadores-simplificados {
      margin-bottom: 24px;
      .cargo-simplificado {
        font-size: 14px;
      }
    }
    .lista-elementos-simplificados {
      display: flex;
      flex-direction: column;
      a {
        width: fit-content;
        margin: 16px 0;
      }
    }
  }
  .container-iframe {
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
    width: calc(100% - 60px);
  }
  .lista-investigadores {
    border-top: 1px solid rgba(0, 0, 0, 0.2);
  }
  .container-btn-txt-sargazo {
    display: flex;
    flex-direction: column;
    align-items: center;
    .btn-conoce-mas {
      width: 149px;
      height: 51px;
      background-color: #9d4637;
      color: #ffffff;
      font-size: 16px;
      font-weight: 600;
      letter-spacing: 0.5px;
      text-align: center;
    }
  }
}
</style>
